import { create } from "zustand";

type HookProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export const useSidebar = create<HookProps>()((set) => ({
  open: true,
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
}));
